import React, { PureComponent } from "react";
import { Icon } from "antd";
import PropTypes from "prop-types";

import styles from "./WrapperPlegable.module.css";

class WrapperPlegable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      plegat: typeof props.plegat !== "undefined" ? props.plegat : true //valor per defecte
    };
  }

  handleOnclick = () => {
    this.setState(state => ({
      ...state,
      plegat: !state.plegat
    }));
  };

  renderTitol() {
    const { titol } = this.props;

    return <div className={styles.WrapperPlegableText}>{titol}</div>;
  }

  renderIcon(plegat) {
    return (
      <div className={styles.WrapperPlegableToggle}>
        <Icon
          type={plegat ? "caret-up" : "caret-down"}
          onClick={this.handleOnclick}
        />
      </div>
    );
  }

  render() {
    const { plegat } = this.state;

    const content = plegat ? null : this.props.children;
    const titol = this.renderTitol();
    const icon = this.renderIcon(plegat);

    return (
      <div className={styles.WrapperPlegable}>
        {titol}
        {icon}

        <div
          className={
            plegat ? (
              styles.WrapperPlegableContentPlegat
            ) : (
              styles.WrapperPlegableContentDesplegat
            )
          }
        >
          {content}
        </div>
      </div>
    );
  }
}

WrapperPlegable.propTypes = {
  titol: PropTypes.string,
  plegat: PropTypes.bool
};

export default WrapperPlegable;
